import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    token: "*****",
    userId: "",
    // 页面刷新key，用于控制keep-alive组件重新创建
    pageRefreshKeys: {} as Record<string, number>,
  }),
  getters: {
    getUserId: (state) => state.userId, // 可选
    // 获取页面刷新key
    getPageRefreshKey: (state) => (pageName: string) => {
      return state.pageRefreshKeys[pageName] || 0;
    },
  },
  actions: {
    // 修改用户名
    changeUserName(token: string) {
      this.token = token;
    },
    setUserId(id: string) {
      this.userId = id;
    },
    // 刷新指定页面（登录成功后调用）
    refreshPage(pageName: string) {
      const currentKey = this.pageRefreshKeys[pageName] || 0;
      this.pageRefreshKeys[pageName] = currentKey + 1;
      console.log(`[页面刷新] ${pageName} 刷新key更新为: ${this.pageRefreshKeys[pageName]}`);
    },
  },
  // 持久化插件配置
  persist: {
    key: "store-user", // 本地存储key名称
    storage: sessionStorage, // 不设置默认存储localStorage
    paths: ["name"], // 指定持久化的值
  },
});
